<template>
  <div style="height: 100%">
    <Header v-if="$route.name !== 'Cards'" />
    <v-main v-if="$route.name === 'Cards'" style="height: 100% !important;">
      <router-view> </router-view>
    </v-main>
    <v-container v-else fluid pa-0 class="main">
      <router-view> </router-view>
    </v-container>

    <Footer v-if="$route.name !== 'Cards'" />
  </div>
</template>

<script>
import { serverBus } from "../main";
import Footer from "./sections/Footer";
import Header from "./sections/Header";

export default {
  components: {
    Footer,
    Header
  },

  data: () => ({
    menu: false,
    navLinks: ["Osnovne informacije", "Shema osoba", "Shema organizacije"]
  }),
  computed: {
    currentRoute() {
      return this.$route.path;
    }
  },
  methods: {
    selectedTab(index) {
      this.menu = false;
      serverBus.$emit("selected-tab", index);
    }
  }
};
</script>

<style>
.main {
  margin-top: 120px;
}

@media only screen and (max-width: 960px) {
  .main {
    margin-top: 80px;
  }

  .v-tabs-slider-wrapper {
    left: unset !important;
    right: 0 !important;
  }

  .v-tabs-bar__content {
    align-items: flex-end !important;
  }
}
</style>
